export enum PlanCode {
  PlanOne = 'Plan 1',
  PlanTwo = 'Plan 2',
}
